import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class StockIssueService extends GenericService {
  constructor() {
    super('/stock_issues', axiosInstance);
  }

  async pushCloud(stockIssueId, payload = {}) {
    try {
      const response = await axiosInstance.post(
        `${this.baseUrl}/${this.encodePathSegment(stockIssueId)}/cloud/push`,
        payload
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new StockIssueService(); 